export const NOTY_GLOBAL_TYPE = {
  INTERNAL_NOTICE: 'INTERNAL_NOTICE',
};

/*
  ORDER_MATERIAL: 발주 내역
  BUDGET: 예산관리
  BUDGET_REQUEST: 예산요청
  SCHEDULE: 일정
  WORK_LOG: 현장보고
  COMMENT: 사내대화방
  COMMENT_CLIENT: 고객대화방
  MINUTES_OF_MEETINGS: 회의록
  FIELD_INVITATION_STAFF: 현장초대 직원
  FIELD_INVITATION_CUSTOMER: 현장초대 고객
  INQUIRY_SETTING_MATERIAL: 1:1문의 - 현장 자재
  INQUIRY_SETTING_FAVORITE: 1:1문의 - 자재 즐겨찾기
  INQUIRY_REQUEST_DESIGN: 1:1문의 - 간편 디자인 신청
  LEDGER: 가계부
  SALES_NOTE: 영업노트
  ORDER_SUPPORT: 상담노트
*/

export const NOTY_FIELD_TYPE = {
  ORDER_MATERIAL: 'ORDER_MATERIAL',
  BUDGET: 'BUDGET',
  BUDGET_REQUEST: 'BUDGET_REQUEST',
  SCHEDULE: 'SCHEDULE',
  WORK_LOG: 'WORK_LOG',
  COMMENT: 'COMMENT',
  COMMENT_CLIENT: 'COMMENT_CLIENT',
  MINUTES_OF_MEETINGS: 'MINUTES_OF_MEETINGS',
  FIELD_INVITATION_STAFF: 'FIELD_INVITATION_STAFF',
  FIELD_INVITATION_CUSTOMER: 'FIELD_INVITATION_CUSTOMER',
  INQUIRY_SETTING_MATERIAL: 'INQUIRY_SETTING_MATERIAL',
  INQUIRY_SETTING_FAVORITE: 'INQUIRY_SETTING_FAVORITE',
  INQUIRY_REQUEST_DESIGN: 'INQUIRY_REQUEST_DESIGN',
  LEDGER: 'LEDGER',
  SALES_NOTE: 'SALES_NOTE',
  ORDER_SUPPORT: 'ORDER_SUPPORT',
};
